type ObjectBase = Record<string, any>;

function arrayHasDuplicates(arr: ObjectBase[], key: keyof ObjectBase) {
  const res = arr.reduce<any[]>((acc, curr) => [...acc, curr[key]], []);
  return new Set(res).size !== res.length;
}

export default arrayHasDuplicates;
